export const currencies = [
  { value: 'USD', label: 'USD ($)', unit: '$' },
  { value: 'EUR', label: 'EUR (€)', unit: '€' }
];

export const CLAIM_TYPES = {
  MEDICAL: 'medical',
  TRAVEL: 'non-medical'
};

export const STEP_PATHS = {
  TRAVEL_INFORMATION: 'travel-information',
  PRE_EX: 'pre-existing-condition',
  DESCRIPTION: 'description',
  OTHER_PARTIES: 'other-parties',
  PERSONAL_INFORMATION: 'personal-information',
  ID_VERIFICATION: 'id-verification',
  UPLOAD_DOCUMENTS: 'upload-documents',
  REIMBURSEMENT: 'reimbursement',
  SUMMARY: 'summary',
  CONFIRMATION: 'confirmation'
};
